import { type RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: '404',
    path: '404',
    component: () => import('../404NotFound.vue'),
  },
  {
    name: '500',
    path: '500',
    component: () => import('../500UnexpectedError.vue'),
  },
];
